import { useQuery } from "@tanstack/react-query";
import { getOrganizationsOptions } from "../../../modules/admin/api/useOrganizations";

export const useMcpSupportedProfiles = () => {
  const { data: amazonProfilesData = [], isLoading: isAmazonLoading } = useQuery(
    getOrganizationsOptions({ channel: "AMAZON", includeMcpToken: true }),
  );
  const { data: walmartProfilesData = [], isLoading: isWalmartLoading } = useQuery(
    getOrganizationsOptions({ channel: "WALMART", includeMcpToken: true }),
  );

  return {
    trellisProfilesData: [...amazonProfilesData, ...walmartProfilesData],
    isLoading: isAmazonLoading || isWalmartLoading,
  };
};
